import _difference from "lodash/difference";

var computeClassNamesDifference = function computeClassNamesDifference(prevClassNames, currentClassNames) {
  return [_difference(currentClassNames, prevClassNames), _difference(prevClassNames, currentClassNames)];
};

export default computeClassNamesDifference;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/MountNode/lib/computeClassNamesDifference.js
// module id = 1480
// module chunks = 1